export const prefix = "cb"
export const iconName = "exclamation-triangle"
export const width = 512
export const height = 512
export const ligatures = []
export const unicode = "f071"
export const svgPathData =
  "M320.5 64C335.2 64 348.7 72.1 355.7 85L571.7 485C578.4 497.4 578.1 512.4 570.9 524.5C563.7 536.6 550.6 544 536.5 544L104.5 544C90.4 544 77.4 536.6 70.2 524.5C63 512.4 62.7 497.4 69.4 485L285.4 85C292.4 72.1 305.9 64 320.6 64zM117.9 496L523.1 496L320.5 120.8L117.9 496zM320.5 456C302.8 456 288.5 441.7 288.5 424C288.5 406.3 302.8 392 320.5 392C338.2 392 352.5 406.3 352.5 424C352.5 441.7 338.2 456 320.5 456zM320.5 248C339.1 248 353.5 264.1 351.5 282.6L344.4 346.7C343 358.8 332.7 368 320.5 368C308.3 368 298 358.8 296.7 346.7L289.6 282.6C287.6 264.1 302 248 320.6 248z"

export const definition = {
  prefix,
  iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
}

export const cbExclamationTriangle = definition
